import { useState } from "react";
import { Plus, Loader2 } from "lucide-react";

/** Quick Add — single input, title + Enter creates a task. No modal, no other required
 * fields (server defaults: self-assigned, Medium priority, manual source). `extraFields` (e.g.
 * project_id) is merged into the create payload untouched — lets the project page auto-fill
 * its own project_id without this component knowing anything about projects. */
export function TaskQuickAdd({ onCreate, placeholder = "Add a task and press Enter…", testId = "task-quick-add" }) {
  const [title, setTitle] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    const t = title.trim();
    if (!t || saving) return;
    setSaving(true);
    try {
      await onCreate(t);
      setTitle("");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex items-center gap-2 px-4 py-2.5 border-b border-hairline bg-surface2/60">
      <Plus className="h-3.5 w-3.5 text-faint shrink-0" />
      <input
        data-testid={testId}
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") submit(); if (e.key === "Escape") setTitle(""); }}
        placeholder={placeholder}
        aria-label="New task title"
        className="flex-1 bg-transparent text-sm text-ink placeholder:text-faint focus:outline-none"
      />
      {saving && <Loader2 className="h-3.5 w-3.5 animate-spin text-faint" />}
    </div>
  );
}
